import { createContext } from "react";
import { getDefaultCountryCode } from "./LocaleService";
var CountryContext = createContext({
  get defaultCountryCode() {
    return "de";
  }
});
export var CountryContextProvider = CountryContext.Provider;
export var CountryContextConsumer = CountryContext.Consumer;
export default CountryContext;